/**
 * Cost analytics API client (P3-F Doc 41).
 */
import { api } from "./client";

export interface DayPoint {
  date: string;
  cost_usd: number;
  runs: number;
  tokens_in: number;
  tokens_out: number;
}

export interface ByDayResponse {
  days: number;
  total_cost_usd: number;
  total_runs: number;
  total_tokens_in: number;
  total_tokens_out: number;
  points: DayPoint[];
}

export interface UserCost {
  user_id: string;
  email: string | null;
  display_name: string | null;
  cost_usd: number;
  runs: number;
  tokens_in: number;
  tokens_out: number;
}

export interface ByUserResponse {
  days: number;
  items: UserCost[];
}

export interface ProviderCost {
  provider: string;
  model: string;
  cost_usd: number;
  runs: number;
  tokens_in: number;
  tokens_out: number;
}

export interface ByProviderResponse {
  days: number;
  total_cost_usd: number;
  items: ProviderCost[];
}

export const costApi = {
  byDay: (days = 7) =>
    api.get<ByDayResponse>("/api/v1/admin/cost/by-day", { query: { days } }),
  byUser: (days = 7, limit = 10) =>
    api.get<ByUserResponse>("/api/v1/admin/cost/by-user", {
      query: { days, limit },
    }),
  byProvider: (days = 7) =>
    api.get<ByProviderResponse>("/api/v1/admin/cost/by-provider", {
      query: { days },
    }),
};
